export default {
      id: "graph-cesim-usage",
      viewBox: "0 0 216 138",
      url: __webpack_public_path__ + "svg/sprite.svg#graph-cesim",
      toString: function () {
        return this.url;
      }
    }